// extracted by mini-css-extract-plugin
module.exports = {"noodle":"styles_noodle__2fHh9","numane":"styles_numane__2roDS","distant":"styles_distant__3-XAT"};